




















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component({
})
export default class TaxaGeral extends Vue {
  loading = false;
  taxaGeral: string | null = null;

  @Prop() readonly totalPago!: number;
  @Prop() readonly sairam!: number;

  mounted() {
    this.fetch();
  }

  @Watch("sairam", {immediate: true})
  fetch() {
    this.loading = true;
    
    if(this.sairam > 0){
      this.taxaGeral = Math.round((this.sairam / this.totalPago) * 100).toFixed(0);
    } else {
      this.taxaGeral = '0';
    }

    this.loading = false;
  }
}
